module.exports = __webpack_public_path__ + "media/3.2bd3f741.mp3";